<!--
 * @Descripttion: 图片属性设置
 * @Author: zenghua.wang
 * @Date: 2021-12-06 10:24:52
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-28 16:50:22
-->
<template>
  <el-collapse v-model="collapse" accordion>
    <el-collapse-item name="1" :title="component.basic">
      <config-base :data="data" />
    </el-collapse-item>

    <el-collapse-item title="图片设置">
      <el-form-item label="隐藏">
        <el-switch v-model="data.option.hide" :active-color="theme.active" :inactive-color="theme.inactive" />
      </el-form-item>

      <el-form-item label="透明度">
        <el-slider v-model="data.option.opacity" :step="0.1" :max="1" />
      </el-form-item>

      <el-form-item label="圆角(px)">
        <el-slider v-model="data.option.borderRadius" :max="200" />
      </el-form-item>

      <el-form-item label="上传图片">
        <el-upload ref="imageUploader" class="config-image-upload" accept="image/*" :show-file-list="false" :limit="1"
          :http-request="onHttpRequest">
          <img v-if="data.option.source" :src="`${FDFS_WEB_SERVER_URL + data.option.source}`" style="width:100px" />
          <i v-else class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <div class="xa-form-tips">
        备注：上传图片的长 x 宽 = {{data.width}}px x {{data.height}}px
      </div>
    </el-collapse-item>

    <el-collapse-item title="旋转动画">
      <el-form-item label="开启">
        <el-switch v-model="data.option.animation" :active-color="theme.active" :inactive-color="theme.inactive" />
      </el-form-item>

      <el-form-item label="旋转时长(ms)" v-if="data.option.animation">
        <el-input-number v-model="data.option.animationTime" :min="1000" />
      </el-form-item>

      <!-- <el-form-item label="旋转方向">
        <el-radio-group
          v-model="data.option.animationRotate"
          size="mini"
        >
          <el-radio-button
            value="anticlockwise"
            label="顺时针"
          ></el-radio-button>
          <el-radio-button
            value="anticlockwise"
            label="逆时针"
          ></el-radio-button>
        </el-radio-group>
      </el-form-item> -->
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  predefineColors,
  component,
  theme,
  FDFS_WEB_SERVER_URL
} from '@/dragComponents/model/default.js'
import apiUpload from '@/dragComponents/mixins/apiUpload'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'

export default {
  name: 'config-image',
  mixins: [apiUpload],
  components: {
    configBase,
    configAuth
  },
  props: ['data', 'collapse'],
  data() {
    return {
      FDFS_WEB_SERVER_URL: FDFS_WEB_SERVER_URL,
      theme: theme,
      predefineColors: predefineColors,
      component: component
    }
  },
  methods: {
    onHttpRequest(file) {
      this.apiUploadPicture(file, (path) => {
        this.data.option.source = path
        // 必须重置uploadFiles，否则二次上传不起作用
        this.$refs.imageUploader.uploadFiles = []
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.config-image {
  &-upload {
    width: 100px;
    height: 100px;
    line-height: 120px;
    border: 1px dashed #ddd;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;

    :deep(.el-upload) {
      width: 100%;
      height: 100%;
    }

    :deep(.el-icon-plus) {
      font-size: 28px;
      color: #8c939d;
    }

    img {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
